import { atomFamily } from "jotai/utils";

import { DigitalJourneyBodyShop } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionBodyShopPostalCodeAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`bodyShopPostalCode-${sessionId}`, "")
);
export const bodyShopPostalCodeAtom = createDerivedSessionAtom<string>(sessionBodyShopPostalCodeAtom);

export const sessionBodyShopAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`bodyShop-${sessionId}`, null as null | DigitalJourneyBodyShop)
);
export const bodyShopAtom = createDerivedSessionAtom<null | DigitalJourneyBodyShop>(sessionBodyShopAtom);
